import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  LinearProgress,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography
} from '@mui/material';
import React, { FC, memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppState, store, useAppSelector } from 'src/store';
import { setDocumentDetail } from 'src/store/documentDetail';
import { setSnackbarMessage } from 'src/store/snackbarMessage';
import DocManagementService from '../documentUpload/service/DocManagementService';

const SendToTmfDialog: FC<any> = ({ openSendToTMF, setOpenSendToTMF, taskId, setIsSentToTMF }: any) => {
  const documentDetail: any = useSelector((state: AppState) => state.documentDetail);
  const docService = new DocManagementService();
  const user: any = useAppSelector(state => state.user.user);
  const userName = `${user.firstName + ' ' + user.lastName}`;
  const [isProcessing, setProcessing] = React.useState(false);
  const [type, setType] = useState('');
  const [subType, setSubType] = useState('');
  const [artifact, setArtifact] = useState('');
  const [artifactNumber, setArtifactNumber] = useState('');
  const isfLevel = 'Site';
  const [issue, setIssue] = useState('');
  const selectedStudy = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Study);
  const selectedCountry = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Country);
  const selectedSite = useSelector((state: AppState) => state.searchHierarchyDetails?.data[0]?.Site);
  const entity = documentDetail?.data[0]?.isf_document_name;

  let IsfLevel =
    (selectedStudy === '--' || selectedStudy === '') &&
    (selectedCountry === '--' || selectedCountry == '') &&
    (selectedSite === '--' || selectedSite === '')
      ? '--'
      : (selectedCountry === '--' || selectedCountry == '') && (selectedSite === '--' || selectedSite === '')
      ? 'Study'
      : selectedSite === '--' && selectedCountry != '--'
      ? 'Country'
      : 'Site';
  if (IsfLevel === '--') {
    IsfLevel = 'Study';
  }
  const dispatch = useDispatch();

  const handleCloseRejectDialog = () => {
    setOpenSendToTMF(false);
  };

  const Data = {
    action_name: 'Sent To TMF',
    sent_to_tmf: true,
    is_resolved: false,
    updated_by: userName
  };

  const handleConfirmClick = async () => {
    setProcessing(true);
    const response = await docService.sendToTMF(
      documentDetail.data[0].task_Id ? documentDetail.data[0].task_Id : taskId,
      Data,
      selectedStudy,
      selectedCountry,
      selectedSite,
      IsfLevel,
      'ISF',
      'DocumentApproval',
      'SentToTMF',
      false
    );
    if (response?.data) {
      setProcessing(false);
      setOpenSendToTMF(false);
      setIsSentToTMF(true);
      store.dispatch(setSnackbarMessage('Document sent to TMF successfully.', 'success'));
      setDocumentDetail(dispatch, [{ ...documentDetail.data[0], sent_to_tmf: true }]);
    } else {
      setProcessing(false);
      store.dispatch(setSnackbarMessage(response.error, 'error'));
    }
  };
  const handleChange = (event: SelectChangeEvent) => {
    setIssue(event.target.value);
  };
  const getDocumentInfo = async (documentID: string) => {
    setProcessing(true);
    const res = await docService.getDocumentInfo(
      documentID,
      selectedStudy,
      selectedCountry,
      selectedSite,
      isfLevel,
      process.env.REACT_APP_NAME,
      'DocumentApproval',
      entity
    );
    if (res?.data) {
      setProcessing(false);
      setType(res?.data?.tmf_type);
      setSubType(res?.data?.tmf_subtype);
      setArtifact(res?.data?.tmf_artifact_name);
      setArtifactNumber(res?.data?.tmf_artifact_number);
    }
  };
  useEffect(() => {
    getDocumentInfo(documentDetail.data[0].id);
  }, []);
  return (
    <Dialog
      open={openSendToTMF}
      onClose={handleCloseRejectDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">To TMF</DialogTitle>
      <DialogContent>
        {isProcessing && (
          <Box sx={{ width: '100%' }} mb={2}>
            <LinearProgress />
          </Box>
        )}
        <DialogContentText id="alert-dialog-description">
          <Typography variant="body1">{`Are you sure you want to send the document to TMF?`}</Typography>
          <>
            <Typography variant="body1" mt={2} mb={1}>
              This document will be mapped to:
            </Typography>
            <Grid container spacing={2}>
              <Grid item md={6} sx={{ pt: 0.5 }}>
                <FormControl variant="standard" fullWidth>
                  <InputLabel id="demo-simple-select-standard-label">TMF Type</InputLabel>
                  <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    value={type}
                    readOnly
                    onChange={handleChange}
                  >
                    <MenuItem value={type}>{type}</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item md={6} sx={{ pt: 0.5 }}>
                <FormControl variant="standard" fullWidth>
                  <InputLabel id="demo-simple-select-standard-label">TMF Subtype</InputLabel>
                  <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    value={subType}
                    readOnly
                    onChange={handleChange}
                  >
                    <MenuItem value={subType}>{subType}</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            <Grid container spacing={2} mt={1}>
              <Grid item md={6} sx={{ pt: 0.5 }}>
                <FormControl variant="standard" fullWidth>
                  <InputLabel id="demo-simple-select-standard-label">Artifact</InputLabel>
                  <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    value={artifact}
                    readOnly
                    onChange={handleChange}
                  >
                    <MenuItem value={artifact}>{artifact}</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item md={6} sx={{ pt: 0.5 }}>
                <FormControl variant="standard" fullWidth>
                  <InputLabel id="demo-simple-select-standard-label">Artifact Number</InputLabel>
                  <Select
                    labelId="demo-simple-select-standard-label"
                    id="demo-simple-select-standard"
                    value={artifactNumber}
                    readOnly
                    onChange={handleChange}
                  >
                    <MenuItem value={artifactNumber}>{artifactNumber}</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseRejectDialog} disabled={isProcessing}>
          Cancel
        </Button>
        <Button autoFocus onClick={handleConfirmClick} disabled={isProcessing}>
          Send
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default memo(SendToTmfDialog);
